<template>
  <div class="toast-container fixed top-4 right-4 z-50 space-y-2">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      :class="[
        'toast px-4 py-3 rounded-lg shadow-lg transition-all duration-300',
        {
          'bg-green-600 text-white': toast.type === 'success',
          'bg-red-600 text-white': toast.type === 'error',
          'bg-yellow-600 text-white': toast.type === 'warning',
          'bg-blue-600 text-white': toast.type === 'info',
        }
      ]"
    >
      <div class="flex items-center justify-between">
        <span>{{ toast.message }}</span>
        <button
          @click="removeToast(toast.id)"
          class="ml-3 text-white hover:text-gray-200"
        >
          ✕
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useToastStore } from '@/stores/toast'

const toastStore = useToastStore()
const { toasts, removeToast } = toastStore
</script>

<style scoped>
.toast {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>